import { ReactComponent as CCSki } from "./CCSki.svg";
import { ReactComponent as alpSki } from "./alpSki.svg";
import { ReactComponent as archery } from "./archery.svg";
import { ReactComponent as artGym } from "./artGym.svg";
import { ReactComponent as artSwim } from "./artSwim.svg";
import { ReactComponent as athletic } from "./athletic.svg";
import { ReactComponent as badminton } from "./badminton.svg";
import { ReactComponent as baseballSoft } from "./baseballSoft.svg";
import { ReactComponent as basket } from "./basket.svg";
import { ReactComponent as beachHand } from "./beachHand.svg";
import { ReactComponent as beachVolley } from "./beachVolley.svg";
import { ReactComponent as biathlon } from "./biathlon.svg";
import { ReactComponent as bob } from "./bob.svg";
import { ReactComponent as boxing } from "./boxing.svg";
import { ReactComponent as breaking } from "./breaking.svg";
import { ReactComponent as canoeFlat } from "./canoeFlat.svg";
import { ReactComponent as canoeSlalom } from "./canoeSlalom.svg";
import { ReactComponent as climbing } from "./climbing.svg";
import { ReactComponent as curling } from "./curling.svg";
import { ReactComponent as cyclingBMXfree } from "./cyclingBMXfree.svg";
import { ReactComponent as cyclingBMXrace } from "./cyclingBMXrace.svg";
import { ReactComponent as cyclingMount } from "./cyclingMount.svg";
import { ReactComponent as cyclingRoad } from "./cyclingRoad.svg";
import { ReactComponent as cyclingTrack } from "./cyclingTrack.svg";
import { ReactComponent as dance } from "./dance.svg";
import { ReactComponent as diving } from "./diving.svg";
import { ReactComponent as fencing } from "./fencing.svg";
import { ReactComponent as figSkate } from "./figSkate.svg";
import { ReactComponent as football } from "./football.svg";
import { ReactComponent as freeSki } from "./freeSki.svg";
import { ReactComponent as futsal } from "./futsal.svg";
import { ReactComponent as golf } from "./golf.svg";
import { ReactComponent as handball } from "./handball.svg";
import { ReactComponent as hockey } from "./hockey.svg";
import { ReactComponent as horse } from "./horse.svg";
import { ReactComponent as iceHockey } from "./iceHockey.svg";
import { ReactComponent as judo } from "./judo.svg";
import { ReactComponent as karate } from "./karate.svg";
import { ReactComponent as luge } from "./luge.svg";
import { ReactComponent as marSwim } from "./marSwim.svg";
import { ReactComponent as modernPenta } from "./modernPenta.svg";
import { ReactComponent as nordic } from "./nordic.svg";
import { ReactComponent as rhythmGym } from "./rhythmGym.svg";
import { ReactComponent as rollerSkate } from "./rollerSkate.svg";
import { ReactComponent as rowing } from "./rowing.svg";
import { ReactComponent as rugby7 } from "./rugby7.svg";
import { ReactComponent as sailing } from "./sailing.svg";
import { ReactComponent as shooting } from "./shooting.svg";
import { ReactComponent as shortSpeedSkate } from "./shortSpeedSkate.svg";
import { ReactComponent as skateboard } from "./skateboard.svg";
import { ReactComponent as skeleton } from "./skeleton.svg";
import { ReactComponent as skiJump } from "./skiJump.svg";
import { ReactComponent as skiMount } from "./skiMount.svg";
import { ReactComponent as snowboard } from "./snowboard.svg";
import { ReactComponent as speedSkate } from "./speedSkate.svg";
import { ReactComponent as surf } from "./surf.svg";
import { ReactComponent as swim } from "./swim.svg";
import { ReactComponent as tableTennis } from "./tableTennis.svg";
import { ReactComponent as taekwondo } from "./taekwondo.svg";
import { ReactComponent as tennis } from "./tennis.svg";
import { ReactComponent as trampoline } from "./trampoline.svg";
import { ReactComponent as triathlon } from "./triathlon.svg";
import { ReactComponent as volleyball } from "./volleyball.svg";
import { ReactComponent as waterPolo } from "./waterPolo.svg";
import { ReactComponent as weightLift } from "./weightLift.svg";
import { ReactComponent as wrestling } from "./wrestling.svg";

const icons = {
  CCSki,
  alpSki,
  archery,
  artGym,
  artSwim,
  athletic,
  badminton,
  baseballSoft,
  basket,
  beachHand,
  beachVolley,
  biathlon,
  bob,
  boxing,
  breaking,
  canoeFlat,
  canoeSlalom,
  climbing,
  curling,
  cyclingBMXfree,
  cyclingBMXrace,
  cyclingMount,
  cyclingRoad,
  cyclingTrack,
  dance,
  diving,
  fencing,
  figSkate,
  football,
  freeSki,
  futsal,
  golf,
  handball,
  hockey,
  horse,
  iceHockey,
  judo,
  karate,
  luge,
  marSwim,
  modernPenta,
  nordic,
  rhythmGym,
  rollerSkate,
  rowing,
  rugby7,
  sailing,
  shooting,
  shortSpeedSkate,
  skateboard,
  skeleton,
  skiJump,
  skiMount,
  snowboard,
  speedSkate,
  surf,
  swim,
  tableTennis,
  taekwondo,
  tennis,
  trampoline,
  triathlon,
  volleyball,
  waterPolo,
  weightLift,
  wrestling,
};

export default icons;
